/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Remove_Aria_LabelInputs */

const en_style_guide_manager_remove_aria_label = /** @type {(inputs: Style_Guide_Manager_Remove_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove selected style guide`)
};

const fr_style_guide_manager_remove_aria_label = /** @type {(inputs: Style_Guide_Manager_Remove_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer le guide de style selectionne`)
};

const de_style_guide_manager_remove_aria_label = /** @type {(inputs: Style_Guide_Manager_Remove_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausgewählten Styleguide entfernen`)
};

const it_style_guide_manager_remove_aria_label = /** @type {(inputs: Style_Guide_Manager_Remove_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rimuovi la guida di stile selezionata`)
};

const ru_style_guide_manager_remove_aria_label = /** @type {(inputs: Style_Guide_Manager_Remove_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удалить выбранную направляющую стиля`)
};

const es_style_guide_manager_remove_aria_label = /** @type {(inputs: Style_Guide_Manager_Remove_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar la guía de estilo seleccionada`)
};

const zh_cn2_style_guide_manager_remove_aria_label = /** @type {(inputs: Style_Guide_Manager_Remove_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`移除选定的样式指南`)
};

const ja_style_guide_manager_remove_aria_label = /** @type {(inputs: Style_Guide_Manager_Remove_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択したスタイルガイドを削除`)
};

const hi_style_guide_manager_remove_aria_label = /** @type {(inputs: Style_Guide_Manager_Remove_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चयनित स्टाइल गाइड को हटाएँ`)
};

const pt_pt2_style_guide_manager_remove_aria_label = /** @type {(inputs: Style_Guide_Manager_Remove_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remover guia de estilo selecionado`)
};

/**
* | output |
* | --- |
* | "Remove selected style guide" |
*
* @param {Style_Guide_Manager_Remove_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_remove_aria_label = /** @type {((inputs?: Style_Guide_Manager_Remove_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Remove_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_guide_manager_remove_aria_label(inputs)
	if (locale === "de") return de_style_guide_manager_remove_aria_label(inputs)
	if (locale === "it") return it_style_guide_manager_remove_aria_label(inputs)
	if (locale === "ru") return ru_style_guide_manager_remove_aria_label(inputs)
	if (locale === "es") return es_style_guide_manager_remove_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_style_guide_manager_remove_aria_label(inputs)
	if (locale === "ja") return ja_style_guide_manager_remove_aria_label(inputs)
	if (locale === "hi") return hi_style_guide_manager_remove_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_style_guide_manager_remove_aria_label(inputs)
	return en_style_guide_manager_remove_aria_label(inputs)
});